// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__6YfCM","table":"Table_table__DjJpI","row":"Table_row__MjWOE","col":"Table_col__TNayF","status":"Table_status__GLSXJ"};